export const STACK = 'flex flex-col gap-2.5';

export const SPREAD = 'flex items-center justify-between gap-2.5';

export const SCREEN =
  'mx-auto flex max-w-[600px] flex-col gap-4 px-[var(--pad)] pt-5 pb-[calc(var(--dock-h,var(--nav-h))/var(--zoom,1)+18px)]';

export const BLEED = '-mx-[var(--pad)]';

export const QBLEED = '-mx-[calc(var(--pad)-6px)]';

export const EYEBROW = 'text-xs font-medium tracking-wide uppercase text-muted-foreground';
export const H_PAGE = 'm-0 text-t24 leading-tight font-extrabold tracking-title';
export const SUB = 'mt-1.5 text-t12 text-faint text-pretty';
export const KICKER = 'text-t10h font-bold tracking-kicker uppercase text-faint';
export const MUTED = 'text-sm leading-[1.45] text-muted-foreground';

export const PLATE = 'relative overflow-hidden rounded-card border border-edge bg-card p-4';

export const ROW =
  'flex w-full items-center justify-between gap-2.5 rounded-card border border-border bg-card px-4.5 py-4.25 text-left text-base font-bold text-foreground [transition:background_0.15s,transform_0.11s_cubic-bezier(0.22,1,0.36,1)] active:bg-muted disabled:cursor-default disabled:opacity-45';
export const ROW_GO = 'flex-none text-base text-muted-foreground';
export const NOTICE_W = 'max-w-[380px]';

export const NOTE =
  'flex flex-col gap-2 rounded-card border border-border border-l-4 border-l-bad bg-card px-4 py-3.5 text-left';

export const SETGROUP =
  'flex flex-col overflow-hidden rounded-card border border-border bg-card [&>*]:rounded-none [&>*]:border-0 [&>*]:border-b [&>*]:border-border [&>*]:bg-transparent [&>*]:px-4.5 [&>*]:py-3.75 [&>*:last-child]:border-b-0';

export const ICON_CHIP =
  'flex size-8 flex-none items-center justify-center rounded-ctl bg-muted text-accent-ink';

export const INPUT =
  'w-full rounded-ctl border border-border-strong bg-card px-3.5 py-3.25 font-sans text-base font-semibold text-foreground outline-none placeholder:font-medium placeholder:text-faint focus:border-accent-ink';

export const DASHED =
  'flex flex-col items-center gap-2 rounded-card border border-dashed border-border-strong px-5 py-7 text-center';

export const BACKLINK =
  '-mt-3 flex min-h-11 items-center gap-1.75 self-start pr-3.5 text-t12 font-semibold tracking-link uppercase text-muted-foreground hover:text-foreground';

export const QTEXT =
  'm-0 text-t19 leading-[1.3] font-extrabold tracking-tight [overflow-wrap:anywhere]';

export const HAZARD =
  "hazard absolute inset-x-0 top-0 h-1.5 overflow-hidden opacity-55 before:absolute before:inset-0 before:-left-7 before:bg-[repeating-linear-gradient(115deg,var(--acc)_0_14px,transparent_14px_28px)] before:content-['']";
